<form id="dialogContainer" class="flex flex-col w-full h-full" [formGroup]="bulkActionForm">

  <div mat-dialog-title>
    <div id="titleIconContainer" class="flex flex-row justify-center items-center">
      <mat-icon svgIcon="update_in_gmb"></mat-icon>
    </div>
    <div id="titleTextContainer" class="flex flex-row justify-center items-center">
      <h1>Bulk accept differences</h1>
    </div>
  </div>

  <mat-dialog-content id="dialogContent" class="flex flex-row">
    @if (!isBulkAcceptConfirmWindow) {
      <div id="stickyLeftPanel">
        <div class="flex flex-col mx-2">
          <div class="flex flex-row">
            <span class="selectionNumber">{{data.locations.length
            + (data.locations.length === 1 ? " location " : " locations ") + "selected"}}</span>
          </div>
          <!-- Field selection template -->
          <div class="fieldSelection flex flex-col mt-[12px]">
            <p class="selectionLabel">Fields</p>
            <mat-radio-group id="fieldSelectionRadioGroup"
              class="flex flex-col"
              name="fieldSelectionRadioGroup"
              formControlName="selectedFieldsRadio">
              @for (radio of selectedFieldsRadios; track radio) {
                <mat-radio-button class="radioButton"
                  [name]="radio"
                  [value]="radio">
                  {{ radio }}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </div>
      </div>
      <!-- Checkboxes -->
      <div class="flex flex-row" formArrayName="selectedFields">
        @for (column of columns; let first = $first; let last = $last; track column) {
          <div class="flex flex-col"
               [ngClass]="{ 'mr-2': !last,
                            'ml-2': first }">
            @for (group of column; track group; let i = $index) {
              <div class="fieldGroupContainer"
                   [ngClass]="{ 'mt-2': i>=1 }">
                <!-- Master checkbox -->
                <mat-checkbox class="fieldGroupCheckbox"
                  [disabled]="isGroupFieldCheckboxDisabled(getFieldIDsByGroup(group))"
                  (change)="toggleFieldGroup(getFieldIDsByGroup(group))"
                  [checked]="allFieldsChecked(getFieldIDsByGroup(group))"
                            [indeterminate]="!allFieldsChecked(getFieldIDsByGroup(group))
                              && someFieldsChecked(getFieldIDsByGroup(group))">
                  {{ group }}
                </mat-checkbox>
                <!-- Checkboxes of a field group -->
                <div class="flex flex-col ml-[32px]">
                  @for (fieldID of getFieldIDsByGroup(group); track fieldID) {
                    <mat-checkbox
                      name="{{ getFieldNameByFieldID(fieldID) }}"
                      [formControlName]="getSelectableFieldIndexByFieldID(fieldID)">
                      <span>{{ getFieldNameByFieldID(fieldID) }} ({{ getDifferencesCountByFieldId(
                      fieldID)}})</span>
                    </mat-checkbox>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="fieldSelection">
        <p class="ml-2">{{ 'Do you really want to update these fields in the selected locations ' +
        '(' + data.locations.length + ')?' }}</p>
        <div class="bulkAcceptDifference_fieldGroupContainer">
          @for (column of columns; track column) {
            <div class="flex flex-col">
              @for (group of column; track group; let i = $index) {
                @if (!!getSelectedFieldIDsByGroup(group).length) {
                  <div
                    class="fieldGroup">
                    <p class="fieldGroupLabel">{{group}}</p>
                    @for (fieldId of getSelectedFieldIDsByGroup(group); track fieldId) {
                      <div
                        mat-menu-item
                        class="fieldCheckbox">
                        {{getFieldNameByFieldID(fieldId)}} ({{ getDifferencesCountByFieldId(fieldId)}})
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    }



    <!-- Confirm template -->

  </mat-dialog-content>

  <mat-dialog-actions id="actionBar"
    align="end">
    <button matButton="outlined"
      id="cancelButton"
      mat-dialog-close
      tabindex="-1"
      [mat-dialog-close]="null">{{'CANCEL' | translate}}
    </button>

    @if (isBulkAcceptConfirmWindow) {
      <button matButton="outlined"
        id="backToPreviewWindowBtn"
              (click)="nextDialogWindow()">Back to field selection
      </button>
    }

    @if (!isBulkAcceptConfirmWindow) {
      <button mat-flat-button color="primary"
        id="confirmButton"
        (click)="nextDialogWindow()"
        [disabled]="!areFieldsSelected()">Continue
      </button>
    } @else {
      <button mat-flat-button color="primary"
        id="acceptButton"
        tabindex="-1"
        [mat-dialog-close]="generateResult()"
        [disabled]="!areFieldsSelected()">Bulk accept differences
      </button>
    }

  </mat-dialog-actions>

</form>
